import Box from "@mui/material/Box";
import { DOMAIN } from "consts/general";
import { Checkbox } from "ui/forms/formik-elements";
import OnboardingForm from 'ui/forms/ECommerce/Onboarding/OnboardingForm';
import { FormField, type OnboardingCompleteOnboaringProps } from './types';

const CompleteOnboarding = <TApplication extends object>({
    values,
    isSubmitting,
    isValid,
    initialValues,
    setFieldValue,
    setFieldTouched,
    handleChange,
    handleBlur,
    handleSubmit,
    ...form
}: OnboardingCompleteOnboaringProps<TApplication>) => (
    <OnboardingForm
        {...form}
        isSubmitting={isSubmitting}
        isValid={isValid}
        handleSubmit={handleSubmit}
        slotProps={{
            submit: {
                sx: {
                    mt: 3,
                    order: -1,
                    maxWidth: 'fit-content'
                },
                children: 'Complete Onboarding'
            }
        }}
    >
        <Checkbox
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
            label={(
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                    }}
                >
                    I agree on
                    <Box
                        component='a'
                        href={`//${DOMAIN}/terms-and-conditions`}
                        sx={{
                            color: theme => theme.palette.common.black,
                            textDecoration: 'underline',
                            fontWeight: 600,
                            cursor: 'pointer'
                        }}
                    >
                        Terms & Conditions *
                    </Box>
                </Box>
            )}
            handleBlur={handleBlur}
            CheckboxProps={{
                inputProps: {
                    'aria-label': 'Agree on Terms & Conditions'
                },
                name: FormField.HasAgreedTermsConditions,
                checked: values[FormField.HasAgreedTermsConditions]
            }}
        />
    </OnboardingForm>
);

export default CompleteOnboarding;
